function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 10,
  fill: "#223130"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9803 16.5468C25.5123 16.6946 25.0197 16.7931 24.5271 16.7931C22.2118 16.7685 20.3399 14.8966 20.3153 12.5813C20.3153 12.1379 20.3892 11.6946 20.537 11.2759C19.9951 10.6847 19.6995 9.92118 19.6995 9.13301C19.6995 8.81281 19.7488 8.49261 19.8473 8.17241C19.2315 8.07389 18.6158 8 18 8C12.4828 8 8 12.4828 8 18C8 23.5172 12.4828 28 18 28C23.5172 28 28 23.5172 28 18C28 17.7783 28 17.5567 27.9754 17.335C27.2611 17.2611 26.5468 16.9901 25.9803 16.5468ZM12.5813 15.3153C14.3054 15.3153 14.3054 18.0246 12.5813 18.0246C10.8571 18.0246 10.6108 15.3153 12.5813 15.3153ZM14.0591 23.7635C12.0887 23.7635 12.0887 20.8079 14.0591 20.8079C16.0296 20.8079 16.0296 23.7635 14.0591 23.7635ZM17.0148 9.33005C18.7389 9.33005 18.7389 12.2857 17.0148 12.2857C15.2906 12.2857 15.0443 9.33005 17.0148 9.33005ZM18.2463 16.8424C19.7241 16.8424 19.7241 18.8128 18.2463 18.8128C16.7685 18.8128 17.0148 16.8424 18.2463 16.8424ZM19.9704 24.9458C18.4926 24.9458 18.4926 22.9754 19.9704 22.9754C21.4483 22.9754 21.202 24.9458 19.9704 24.9458ZM24.6503 21.1034C23.4187 21.1034 23.4187 19.133 24.6503 19.133C25.8818 19.133 25.8818 21.1034 24.6503 21.1034Z",
  fill: "#35ACA8"
});

function SvgCookiesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiesIcon);
export default __webpack_public_path__ + "static/media/CookiesIcon.ed2d6ccc.svg";
export { ForwardRef as ReactComponent };